<section>
  <h2>Basic Tracking Data</h2>
  <form [formGroup]="trackingDataForm" class="w-lg-75">
    <div class="mb-3">
      <label for="InformationTrackingNumber" class="form-label">Information report tracking number</label>
      <input readonly="readonly" aria-readonly="true" type="text" id="InformationTrackingNumber" class="form-control" formControlName="IntelligenceTrackingNumber" />
    </div>
    <div class="mb-3">
      <label for="CGICCode" class="form-label required-field">Field Division</label>
      <select #fd id="CGICCode" formControlName="CGICCode" class="form-select" required aria-required="true">
        <option value="">Select a field division</option>
        <ng-container *ngIf="fieldDivisions$ | async as fds">
          <option *ngFor="let fd of fds" value="{{fd.ENESS_REF_NIBINCGICCodes.OrganizationCode}}">{{fd.FieldDivisionName}}</option>
        </ng-container>
      </select>
      <div class="invalid-feedback">
        Please select a field division.
      </div>
    </div>
    <div class="mb-3">
      <label for="Title" class="form-label required-field">Title</label>
      <input type="text" id="Title" class="form-control" formControlName="Title" required aria-required="true" />
      <div class="invalid-feedback">
        Please provide the report title.
      </div>
    </div>
    <div class="mb-3">
      <label for="PriorityID" class="form-label required-field">Priority</label>
      <select id="PriorityID" class="form-select" formControlName="PriorityID" required aria-required="true">
        <option value="">Select priority</option>
        <option *ngFor="let priority of priorities" value="{{priority.PriorityID}}">{{priority.Priority}}</option>
      </select>
      <div class="invalid-feedback">
        Please provide the priority.
      </div>
    </div>
    <div class="mb-3">
      <label for="StatusID" class="form-label required-field">Status</label>
      <select id="StatusID" class="form-select" formControlName="StatusID" required aria-required="true">
        <option value="">Select status</option>
        <option *ngFor="let status of statuses" value="{{status.StatusID}}">{{status.Status}}</option>
      </select>
      <div class="invalid-feedback">
        Please select the report status.
      </div>
    </div>
    <div class="mb-3 table-responsive">
      <table class="temp-bs table table-sm table-striped table-bordered">
        <caption class="caption-top form-label text-body required-field">Assigned Personnel</caption>
        <thead>
          <tr>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Email</th>
            <th scope="col">Primary</th>
            <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="ENESS_XREF_IRsAssignedCGICPersonnel.controls.length == 0;else psnlrows">
            <tr><td colspan="5">No assigned personnel found.</td></tr>
          </ng-container>
          <ng-template #psnlrows>
            <tr formArrayName="ENESS_XREF_IRsAssignedCGICPersonnel" *ngFor="let psnl of ENESS_XREF_IRsAssignedCGICPersonnel.controls; let i = index">
              <th scope="row">{{psnl.get('ENESS_ApplicationUser.FirstName').value}}</th>
              <td>{{psnl.get('ENESS_ApplicationUser.LastName').value}}</td>
              <td>{{psnl.get('ENESS_ApplicationUser.Email').value}}</td>
              <td [formGroupName]="i" class="text-center">
                <input #psnlrb type="radio" class="form-check-input" [checked]="psnl.get('IsPrimary').value" (change)="onSelectPrimaryPersonnel($event, psnl.get('UserID').value)" name="IsPrimary" aria-label="Primary assigned personnel" />
              </td>
              <td class="text-center">
                <button type="button" title="Delete assigned personnel" (click)="ENESS_XREF_IRsAssignedCGICPersonnel.removeAt(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete assigned personnel</span></button>
              </td>
            </tr>
          </ng-template>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5" class="p-3">
              <div class="row row-cols-lg-auto gy-2 gx-3 align-items-start">
                <div class="col-12">
                  <label for="PersonnelCGICCode" class="form-label required-field">Field Division</label>
                  <select #pfd id="PersonnelCGICCode" class="form-select" (change)="onChangeFD($event, pfd.value)" required aria-required="true">
                    <option value="">Select a field division</option>
                    <ng-container *ngIf="fieldDivisions$ | async as fds">
                      <option *ngFor="let fd of fds" value="{{fd.ENESS_REF_NIBINCGICCodes.OrganizationCode}}">{{fd.FieldDivisionName}}</option>
                    </ng-container>
                  </select>
                </div>
                <div class="col-12">
                  <label for="CGICPersonnel" class="form-label required-field">Assigned Personnel</label>
                  <p-multiSelect #assgnd [disabled]="!pfd.value" inputId="CGICPersonnel" [maxSelectedLabels]="2" [tabindex]="0" [options]="cgicPersonnel" styleClass="form-select" placeholder="Choose the assigned personnel" ariaFilterLabel="Filter assigned personnel" appendTo="body">
                  </p-multiSelect>
                </div>
              </div>
              <button type="button" class="btn btn-sm btn-success mt-3" [disabled]="!assgnd.value" (click)="addAssignedPersonnel($event, assgnd)"><i class="fa fa-plus" aria-hidden="true"></i> Add assigned personnel</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="mb-3">
      <fieldset>
        <legend class="required-field form-label">Type</legend>
        <ng-container formArrayName="ENESS_XREF_IRsTypes" *ngFor="let type of types; let i = index">
          <div class="form-check" [formGroupName]="i">
            <input #typeChbx id="{{types[i].TypeID}}" class="form-check-input" type="checkbox" formControlName="chbx" value="{{types[i].TypeID}}" (change)="typeChbx.checked ? getENESS_XREF_IRsTypes(i).get('OtherText').enable() : getENESS_XREF_IRsTypes(i).get('OtherText').disable() ">
            <label class="form-check-label" for="{{types[i].TypeID}}">{{types[i].Type}}</label>
          </div>
          <div class="form-group ms-4" [formGroupName]="i" *ngIf="types[i].Type == 'Other'" [hidden]="!typeChbx.checked">
            <label for="OtherText" class="form-label required-field">Other report type</label>
            <input #otherText type="text" id="OtherText" class="form-control" formControlName="OtherText" required aria-required="true" />
            <div class="invalid-feedback">
              Please provide the other report type (maximum 80 characters).
            </div>
          </div>
        </ng-container>
        <div class="cross-validation-feedback" *ngIf="ENESS_XREF_IRsTypes.hasError('multipleCheckboxRequireOne') ">
          Please provide the report type.
        </div>
      </fieldset>
    </div>
    <div class="mb-3">
      <fieldset>
        <legend class="required-field form-label">Purpose</legend>
        <ng-container formArrayName="ENESS_XREF_IRsPurposes" *ngFor="let purpose of purposes; let i = index">
          <div class="form-check" [formGroupName]="i">
            <input #chbx id="{{purposes[i].PurposeID}}" class="form-check-input" type="checkbox" formControlName="chbx" value="{{purposes[i].PurposeID}}" (change)="onPurposeChange($event, i)" />
            <label class="form-check-label" for="{{purposes[i].PurposeID}}">{{purposes[i].Purpose}}</label>
          </div>
          <div [hidden]="!chbx.checked" [formGroupName]="i" class="my-2" style="margin-left: 1.5em;" *ngIf="purposes[i].Purpose !== 'External LE Case Assist/NIBIN Notification'">
            <ng-container formGroupName="ENESS_XREF_IRsPurposesFieldDivisions">
              <label class="form-label required-field" for="{{'FieldDivisionID'+i}}">Field division</label>
              <select class="form-select" formControlName="FieldDivisionID" id="{{'FieldDivisionID'+i}}" (change)="onDivisionChange($event, i)" required aria-required="true">
                <option value="">Select the field division</option>
                <option value="{{fieldDiv.FieldDivisionID}}" *ngFor="let fieldDiv of fieldDivisions$ | async">{{fieldDiv.FieldDivisionName}}</option>
              </select>
              <div class="invalid-feedback">
                Please provide the field division.
              </div>
            </ng-container>
          </div>
          <div [hidden]="!chbx.checked" [formGroupName]="i" class="my-2" style="margin-left: 1.5em;" *ngIf="purposes[i].Purpose !== 'External LE Case Assist/NIBIN Notification'">
            <ng-container formGroupName="ENESS_XREF_IRsPurposesFieldDivisions">
              <label class="form-label required-field" for="{{'GroupID'+i}}">Group</label>
              <select class="form-select" formControlName="IntelligenceReportATFReferralGroupsID" id="{{'GroupID'+i}}" required aria-required="true">
                <option value="">Select the group</option>
                <ng-container *ngIf="purposes[i].PurposeID.toLowerCase() == 'ad50aab0-767f-4b44-bcdf-5b04435a287d'">
                  <option value="{{group.IntelligenceReportATFReferralGroupsID}}" *ngFor="let group of filteredReferralGroupsForCaseAssist" [class.text-muted]="group.Inactive" [disabled]="group.Inactive">{{group.GroupName}} ({{group.Inactive | booleanTransform: 'Inactive' :'Active'}})</option>
                </ng-container>
                <ng-container *ngIf="purposes[i].PurposeID.toLowerCase() == '044e5fbd-ecd4-49d4-a4ee-61ff70c7855b'">
                  <option value="{{group.IntelligenceReportATFReferralGroupsID}}" *ngFor="let group of filteredReferralGroupsForReferral" [class.text-muted]="group.Inactive" [disabled]="group.Inactive">{{group.GroupName}} ({{group.Inactive | booleanTransform: 'Inactive' :'Active'}})</option>
                </ng-container>
              </select>
              <div class="invalid-feedback">
                Please provide the group.
              </div>
            </ng-container>
          </div>
          <div [hidden]="!chbx.checked" [formGroupName]="i" class="my-2" style="margin-left: 1.5em;" *ngIf="purposes[i].Purpose == 'ATF Case Assist'">
            <ng-container formGroupName="ENESS_XREF_IRsPurposesFieldDivisions">
              <label class="form-label required-field" for="{{'NFORCECaseNumber'+i}}">NFORCE case number (format: 999999-99-9999)</label>
              <p-inputMask formControlName="NFORCECaseNumber" typeof="text" mask="999999-99-9999" [inputId]="'NFORCECaseNumber'+i" styleClass="form-control" [required]="true" [ariaRequired]="true"></p-inputMask>
              <div class="invalid-feedback">
                Please provide the NFORCE case number.
              </div>
            </ng-container>
          </div>
          <div [hidden]="!chbx.checked" [formGroupName]="i" class="form-group ms-4" *ngIf="purposes[i].Purpose == 'ATF Referral'">
            <ng-container formGroupName="ENESS_XREF_IRsPurposesFieldDivisions">
              <label for="{{'NFORCECaseNumber'+i}}">NFORCE case number (format: 999999-99-9999)</label>
              <p-inputMask formControlName="NFORCECaseNumber" typeof="text" mask="999999-99-9999" [inputId]="'NFORCECaseNumber'+i" styleClass="form-control"></p-inputMask>
              <div class="invalid-feedback" *ngIf="getENESS_XREF_IRsPurposesFieldDivisionsFormGroup(i).get('NFORCECaseNumber').invalid">
                Please provide a valid NFORCE case number.
              </div>
            </ng-container>
          </div>
        </ng-container>
        <div class="cross-validation-feedback" *ngIf="ENESS_XREF_IRsPurposes.hasError('multipleCheckboxRequireOne')">
          Please provide the purpose.
        </div>
      </fieldset>
    </div>
  </form>
</section>
